import BaseController from 'Controllers/User/_BaseController';
import LoginController from 'Vue/Web/Common/User/Login.vue';

global.Controller = new class extends BaseController {
    LoginController ?: Vue;

    ready() {
        super.ready();

        this.LoginController = new Vue({
            ...LoginController,
            el: '.wrap',
            propsData: {
                loginUrl: Json.loginUrl,
                previousPage: Json.previousPage,
            },
        });
    }
};
